import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';

/**
 * Do not instantiate but extend this class to create carousel popups.
 */
@Component({
  template: '',
  standalone: true,
})
export abstract class CarouselPopupComponent implements AfterViewInit, OnDestroy {
  protected readonly animationDone = new BehaviorSubject<boolean>(false);
  protected readonly componentDestroyed = new Subject<void>();

  public readonly animationDone$ = this.animationDone.asObservable();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              protected dialogRef: MatDialogRef<CarouselPopupComponent>) {
  }

  ngAfterViewInit() {
    // workaround to mitigate close button position jumping
    // https://github.com/angular/components/issues/23851
    this.dialogRef.afterOpened()
        .pipe(take(1))
        .subscribe(() =>
            setTimeout(() => this.animationDone.next(true), 50));
  }

  ngOnDestroy() {
    this.componentDestroyed.next();
  }
}